import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as R from 'ramda'
import { Button, Divider as UnstyledDivider } from 'semantic-ui-react'

import { AddRuleDropdown } from './AddRuleDropdown'
import { AudienceRuleInput } from 'components/AudienceRuleInput'

const Container = styled.div`
  max-width: 400px;
`

const Divider = styled(UnstyledDivider)`
  text-transform: inherit !important;

  &:last-of-type {
    display: none !important;
  }
`

export class AudienceRuleGroup extends React.Component {
  static propTypes = {
    namePrefix: PropTypes.string,
    rules: PropTypes.array,
    operator: PropTypes.oneOf(['and', 'or']),
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        field_type: PropTypes.string,
      }).isRequired
    ),
    onChange: PropTypes.func,
    shouldShowAutocomplete: PropTypes.bool,
    shouldEnableFourComparison: PropTypes.bool,
  }

  id = 1

  static defaultProps = {
    fields: [],
    onChange: () => {},
  }

  state = {
    rules: this.addIdToAudienceRule(this.props.rules),
  }

  addIdToAudienceRule(rules = []) {
    return rules.map((rule) => {
      rule['_id'] = this.id++
      return rule
    })
  }

  addRule = (field) => {
    this.setState(
      (prevState) => ({
        rules: prevState.rules.concat({
          _id: this.id++,
          condition: 'is',
          field,
          value: '',
          operator: this.props.operator,
        }),
      }),
      () => {
        this.props.onChange(R.prop('rules', this.state))
      }
    )
  }

  removeRuleAtIndex(index) {
    this.setState(
      (prevState) => ({
        rules: R.remove(index, 1, prevState.rules),
      }),
      () => {
        this.props.onChange(R.prop('rules', this.state))
      }
    )
  }

  updateRuleAtIndex(index, rule) {
    this.setState(
      (prevState) => ({
        rules: R.update(index, R.merge(this.state.rules[index], rule), prevState.rules),
      }),
      () => {
        this.props.onChange(R.prop('rules', this.state))
      }
    )
  }

  closeModal() {
    this.setState({ isShowingDropdown: false })
  }

  render() {
    const { fields } = this.props

    return (
      <Container>
        {this.state.rules.map((rule, index) => {
          const isRuleFromApi = Boolean(rule.id)
          return (
            <React.Fragment key={rule._id}>
              <AudienceRuleInput
                shouldAutoFocus={!isRuleFromApi}
                namePrefix={this.props.namePrefix}
                index={index}
                value={rule}
                field={rule.field}
                onDismiss={() => this.removeRuleAtIndex(index)}
                onChange={(rule) => this.updateRuleAtIndex(index, rule)}
                shouldShowAutocomplete={this.props.shouldShowAutocomplete}
                shouldEnableFourComparison={this.props.shouldEnableFourComparison}
              />
              <Divider horizontal>{this.props.operator}</Divider>
            </React.Fragment>
          )
        })}
        <Button
          className="mt3"
          basic
          fluid
          onClick={(e) => {
            e.preventDefault()
            this.setState({
              isShowingDropdown: true,
            })
          }}
        >
          <i className="icon far fa-plus" />
          Add a rule
        </Button>
        {this.state.isShowingDropdown && (
          <AddRuleDropdown
            fields={fields}
            onChange={(rule) => {
              this.addRule(rule)
              this.closeModal()
            }}
            onClose={() => this.closeModal()}
          />
        )}
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/AudienceRuleGroup/index.js